module.exports = __webpack_public_path__ + "img/icon-goal-4.56faf49e.svg";